<template>
  <modal
      id="location-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Location')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :hide-cancel-button="makeDefault"
      :close-button="!makeDefault"
      :modal-backdrop="!makeDefault"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        :data-url='selectedUrl ? selectedUrl : LOCATION_CREATE'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-6">
          <app-form-group
              :label="$t('name')"
              :placeholder="$placeholder('name')"
              v-model="formData.name"
              :required="true"
              :error-message="$errorMessage(errors, 'name')"
          />
        </div>
        <div class="col-md-6">
            <app-form-group
                :label="$t('alias')"
                :placeholder="$placeholder('alias')"
                v-model="formData.alias"
                :required="true"
                :error-message="$errorMessage(errors, 'alias')"
            />
        </div>
        <div class="col-md-6">
          <app-form-group
              :label="$t('latitude')"
              :placeholder="$placeholder('latitude')"
              v-model="formData.latitude"
              :required="true"
              :error-message="$errorMessage(errors, 'latitude')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              :label="$t('longitude')"
              :placeholder="$placeholder('longitude')"
              v-model="formData.longitude"
              :required="true"
              :error-message="$errorMessage(errors, 'longitude')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-form-group
              :label="$t('radius')"
              :placeholder="$placeholder('radius_in_meter')"
              v-model="formData.radius"
              :required="true"
              :error-message="$errorMessage(errors, 'radius')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="textarea"
              :label="$t('address')"
              :placeholder="$placeholder('address')"
              v-model="formData.address"
              rows="5"
              :required="true"
              :error-message="$errorMessage(errors, 'address')"
          />
        </div>
      </div>


<!--      <div class="row" v-if="preloader">-->
<!--        <div class="col-md-12">-->
<!--          <span>Loading...</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="row">
        <div class="col-md-12">
          <span class="w-100 text-center d-flex flex-column" v-if="loading" style="margin-top: 4rem; margin-bottom: 4rem;">
            <span class="spinner-bounce" :class="loaderColor">
                <span class="bounce1 bg-white mr-1"/>
                <span class="bounce2 bg-white mr-1"/>
                <span class="bounce3 bg-white mr-1"/>
            </span>
          </span>
          <div id="googleMap" style="height: 250px; width: 100%;"></div>
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  AUTO_EMPLOYEE_ID, LOCATION_CREATE,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
  TENANT_EMAIL_SETUP_SETTING
} from "../../../../common/Config/apiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";
import {addChooseInSelectArray} from "../../../../common/Helper/Support/FormHelper";
import {toNumber} from "lodash/lang";
import mapboxgl from "mapbox-gl";
import GoogleMapsMixins from "../../Mixins/GoogleMapsMixins";
import LogMixin from "../../Mixins/LogMixin";
import Loader from "../../../../core/components/preloders/Loader";

export default {
  name: "LocationCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, GoogleMapsMixins, LogMixin],
  props: {
    from: {
      type: String,
      default: 'location'
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    },
    makeDefault: {
      type: Boolean,
      default: false,
    },
    wizard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maps: null,
      isMailSettingExist: true,
      preloader: true,
      loading: false,
      formData: {
        name: "",
        latitude: 0.0,
        longitude: 0.0,
        alias: "",
        address: "",
        radius: 50,
        data: {},
      },
      // EMPLOYEES_LIST,
      // SELECTABLE_DEPARTMENT,
      // SELECTABLE_ROLE,
      // SELECTABLE_DESIGNATION,
      // SELECTABLE_EMPLOYMENT_STATUS,
      LOCATION_CREATE,
      // TENANT_EMAIL_SETUP_SETTING,
    }
  },
  methods: {
    submit() {
      console.log(this.formData);
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};
      this.formData.latitude = parseFloat(this.formData.latitude);
      this.formData.longitude = parseFloat(this.formData.longitude);
      // this.formData.alias = formatDateForServer(this.formData.contract_start_date);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#location-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'location' ? 'location-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      //Before customization this was "  this.formData = data;"
      this.formData = {...this.formData, ...data};
      this.formData.employee_id = data.profile?.employee_id;
      this.formData.roles = this.collection(data.roles).pluck();
      this.formData.designation_id = data.designation?.id;
      this.formData.department_id = data.department?.id;
      this.formData.employment_status_id = data.employment_status?.id;
      this.formData.dont_show_in_employee = parseInt(this.formData.is_in_employee) ? 0 : 1;
      this.formData.joining_date = data.profile?.joining_date ? new Date(data.profile?.joining_date) : null;
      this.formData.gender = data.profile?.gender;
      this.formData.nationality = data.profile.nationality;
      this.formData.contract_start_date = data.profile.contract_start_date;
      this.formData.contract_end_date = data.profile.contract_end_date;
    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
    checkEmployeeID() {
      axiosGet(AUTO_EMPLOYEE_ID).then(response => {
        this.formData.employee_id = response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    loadGoogleMapsScript() {
      return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined' && google.maps) {
          resolve();
        } else {
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
          script.async = true;
          script.defer = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        }
      });
    },
    getMapElement() {
      return document.querySelector('#googleMap');
    },
    initMap() {
      const loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
        language: window.appLanguage,
        libraries: ["places"]
      });

      const mapElement = this.getMapElement();
      console.log('initMap===>>', mapElement);
      if (mapElement) {
        console.log('map element found');
        this.geoLoader = false;
        return;
      } else {
        console.error('Map element not found');
        this.getMapElement();
      }

      const mapOptions = {
        center: this.center,
        zoom: 16,
        gestureHandling: "cooperative",
        radius: 50
      };
      loader
          .load()
          .then((google) => {
            this.preloader = false;
            this.mapGoogle = new google.maps.Map(mapElement, mapOptions);
            new google.maps.Marker({
              position: this.center,
              map: this.mapGoogle,
            });
          })
          .catch(err => {
            console.log(err)
            this.geoLoader = false;
          });
      // var sydney = new google.maps.LatLng(-33.867, 151.195);
      //
      // let infowindow = new google.maps.InfoWindow();
      //
      // map = new google.maps.Map(
      //     document.getElementById('map'), {center: sydney, zoom: 15});
      //
      // var request = {
      //     query: 'Museum of Contemporary Art Australia',
      //     fields: ['name', 'geometry'],
      // };
      //
      // var service = new google.maps.places.PlacesService(map);
      //
      // service.findPlaceFromQuery(request, function(results, status) {
      //     if (status === google.maps.places.PlacesServiceStatus.OK) {
      //         for (var i = 0; i < results.length; i++) {
      //             createMarker(results[i]);
      //         }
      //         map.setCenter(results[0].geometry.location);
      //     }
      // });
    },
  },
  created() {
    console.log('created', this.formData);
    this.checkMailSettings();
    if (!this.selectedUrl) {
      this.checkEmployeeID();
    }
  },
  computed: {},
  mounted() {
    console.log('mounted');
  },
}
</script>